<template>
	<div class="steps">
      <div class="step" v-if="addType === 'agent'">
        <img v-if="active === 1" class="titleImg" src="@/assets/first.png" width="88%">
        <img v-else-if="active === 2" class="titleImg" src="@/assets/second.png" width="88%">
        <img v-else-if="active === 3" class="titleImg" src="@/assets/third.png" width="88%">
        <img v-else class="titleImg" src="@/assets/fourth.png" width="88%">
        <div class="stepTitle">
          <p :class="active >= 1 ? 'active' : ''">基本信息</p>
          <p :class="active >= 2 ? 'active' : ''">证件信息</p>
          <p :class="active >= 3 ? 'active' : ''">账户信息</p>
          <p :class="active === 4 ? 'active' : ''">结算信息</p>
        </div>
      </div>
      <div class="step" v-else>
        <img v-if="active === 1" class="titleImg" src="@/assets/merchant/first.png" width="88%">
        <img v-else-if="active === 2" class="titleImg" src="@/assets/merchant/second.png" width="88%">
        <img v-else class="titleImg" src="@/assets/merchant/third.png" width="88%">
        <div class="stepTitle">
          <p :class="active >= 1 ? 'active' : ''">商户信息</p>
          <p :class="active >= 2 ? 'active' : ''">店铺信息</p>
          <p :class="active === 3 ? 'active' : ''">银行账号</p>
        </div>
      </div>  
  </div>
</template>

<script>
export default{
  props: {
    active: {
      type: Number,
      default: 1
    },
    addType: {
      type: String,
      default: 'agent'
    }
  },
  name: 'steps'
};
</script>

<style scoped>
.step{
  padding: 10% 5%;
}
.stepTitle{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.stepTitle>p{
  margin: 0;
  font-size: 14px;
  color: #D8DFEC;
}
.stepTitle>p.active{
  color: #4A4A4A;
}
.titleImg{
  margin-left: 6%;
}
</style>